import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_erp92b0r5e: FaireBrandEntity = {
  token: "b_erp92b0r5e",
  type: "brand",
  name: "Manifest Wellness",
  avatarUrl:
    "https://cdn.faire.com/fastly/93f51a8a98a70d364b510371739624c001584e813afcbf42d9085baeaf2f8c21.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1cfef174060f83dde6fda49e02f5416acafe2125cf5fa3534a7b123d4bace966.png",
  logoUrl:
    "https://cdn.faire.com/fastly/93f51a8a98a70d364b510371739624c001584e813afcbf42d9085baeaf2f8c21.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1cfef174060f83dde6fda49e02f5416acafe2125cf5fa3534a7b123d4bace966.png",
  location: "Orlando, FL, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 183,
  isTopShop: true,
  isInsider: true,
  description:
    "We are passionate about making effective products with clean, organic ingredients that are good for your body, mind, and the earth. We meticulously research every ingredient that goes into our products and proudly handcraft our health and wellness products without chemicals, toxins, harmful preservatives, or animal testing. We believe firmly in packaging our products in glass to prevent plastic leaching and to help make our product packaging as recyclable or reusable as possible. We believe in quality, purity, and true holistic health.\n\nFounded in 2004, Manifest Wellness owner Jeannine Gimbel started crafting wellness products to help her special needs son. Having difficulty finding products free from harmful preservatives, chemicals, and other toxins, she started making and selling her products in local stores and farmers' markets and has since expanded to independent Spas, health food stores, and Health Clinics across the US. Jeannine is passionate about health and wellness and has received certifications as a Health Coach, Reiki Master, and Herbalist. She draws from all of these when creating her products.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:47.414Z",
    importedBy: "entity-db-cli",
  },
};
